import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchAdminUsers } from "../api/user.api";

interface UseAdminsProps {
  isAdmin: boolean;
}

const useAdmins = ({ isAdmin }: UseAdminsProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken]),
  );

  const {
    data: usersData,
    error: usersError,
    isLoading: adminsIsLoading,
  } = useQuery({
    queryKey: ["allUsers"],
    queryFn: () => fetchAdminUsers(bearerToken as string),
    enabled: !!bearerToken && isAdmin,
  });

  return {
    admins: usersData,
    adminsIsLoading,
  };
};

export default useAdmins;
